import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'

const configureDayjs = () => {
    dayjs.extend(customParseFormat)
    dayjs.extend(isSameOrAfter)
    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.extend(relativeTime)
}

export default configureDayjs
